'use client'
import { type FC, memo } from 'react'
import type { TypeCmsProjectCard, TypeCmsProjectDetail } from '@/schema'
import { SectionFavourites } from './SectionFavourites'
import { SectionRelatedProject } from './SectionsRelatedProject'
import { SectionContents } from './SectionContents'
import styled from 'styled-components'

type Props = {
  data: {
    contents: TypeCmsProjectDetail['contents']
    relatedProjects: TypeCmsProjectCard[]
    relatedProducts: TypeCmsProjectDetail['related_products']
  }
}

export const MainProject:FC<Props> = memo(({ data }) => {
  const { contents, relatedProjects, relatedProducts } = data

  return (
    <Main>
      {contents && <SectionContents data={contents} />}
      {relatedProducts?.length > 0 && <SectionFavourites data={relatedProducts} isSmallHeadline />}
      {relatedProjects?.length > 0 && <SectionRelatedProject data={relatedProjects} />}
    </Main>
  )
})


const Main = styled.main`
  width: 100vw;
  width: 100dvw;
`
